import { State } from '@meraki-internal/state';
import { ITrackingFrom } from '../ITrackingFrom';

/**
 * Shared open/close state for the Care Code confirmation modal so it can be opened from the main
 * menu and the care recipient menu rather than from either component's local useState. The modal
 * itself is rendered once at the app shell.
 */
export class CareCodeModalState extends State {
    constructor() {
        super({});
    }

    isOpen = false;
    trackingFrom: ITrackingFrom = 'Main Menu';

    open = (trackingFrom: ITrackingFrom) => {
        if (!this.isOpen) {
            this.isOpen = true;
            this.trackingFrom = trackingFrom;
            this.setState({});
        }
    };

    close = () => {
        if (this.isOpen) {
            this.isOpen = false;
            this.setState({});
        }
    };
};
